export const nav = {
  home: "Home",
  about: "Chi Siamo",
  services: "I Nostri Servizi",
  projects: "Progetti",
  expertise: "Competenze",
  contact: "Contatti",
  requestConsultation: "Richiedi Consulenza"
};

export const hero = {
  title: "Ingegneria del Futuro dell'Energia Rinnovabile",
  subtitle: "con Competenza Globale in Solare, Eolico e Accumulo"
};

export const services = {
  sectionLabel: "Le Nostre Competenze Ingegneristiche",
  sectionTitle: "Soluzioni Integrate di Ingegneria per l'Energia Rinnovabile",
  solar: {
    title: "Sistemi di Energia Solare",
    description: "Servizi di ingegneria fotovoltaica per impianti solari utility-scale e commerciali, inclusi studi di fattibilità, progettazione di sistemi, modellazione delle prestazioni e ottimizzazione per la resa energetica e l'economia del progetto."
  },
  wind: {
    title: "Soluzioni di Energia Eolica",
    description: "Supporto avanzato allo sviluppo di parchi eolici, inclusa la selezione delle turbine e l'analisi delle prestazioni per progetti onshore e offshore."
  },
  battery: {
    title: "Sistemi di accumulo a batteria",
    description: "Integrazione di sistemi di accumulo energetico, progettazione BESS e soluzioni di batterie su scala di rete per migliorare affidabilità e flessibilità."
  },
  grid: {
    title: "Integrazione di Rete",
    description: "Studi sui sistemi elettrici, ingegneria di connessione alla rete e soluzioni di conformità per un'integrazione perfetta dell'energia rinnovabile."
  }
};

export const about = {
  sectionLabel: "CHI È SALL ENGINEERING",
  sectionTitle: "Eccellenza Ingegneristica Globale nelle Soluzioni di Energia Rinnovabile",
  paragraph1: "SALL Engineering è la divisione di ingegneria e consulenza nel settore delle energie rinnovabili di SALL Collection Tekstil Sanayi ve Ticaret A.Ş., con sede a Istanbul, Turchia. L'azienda fornisce soluzioni tecniche avanzate per progetti solari, eolici e di accumulo energetico nei mercati globali.",
  noteLabel: "Nota Aziendale:",
  noteText: "SALL Engineering opera come parte di SALL Collection Tekstil Sanayi ve Ticaret A.Ş., una holding diversificata con attività in diversi settori industriali."
};

export const projects = {
  sectionLabel: "PROGETTI IN EVIDENZA",
  sectionTitle: "Esperienza Selezionata in Progetti di Energia Rinnovabile",
  solar: {
    category: "Energia Solare",
    title: "Fotovoltaico utility-scale — supporto ingegneristico",
    scope: "L'ambito include studi di fattibilità, progettazione di sistemi FV, modellazione della resa e ottimizzazione."
  },
  wind: {
    category: "Energia Eolica",
    title: "Energia Eolica — Valutazione delle Risorse e Analisi della Resa",
    scope: "L'ambito include valutazione delle risorse, ottimizzazione del layout, supporto alla selezione delle turbine e analisi della resa energetica."
  },
  storage: {
    category: "Accumulo Energetico",
    title: "Accumulo Energetico a Batteria — Integrazione di Rete e Dimensionamento",
    scope: "L'ambito include dimensionamento BESS, studi di integrazione di rete, scenari operativi e valutazione delle prestazioni."
  }
};

export const expertise = {
  sectionLabel: "COMPETENZE TECNICHE",
  sectionTitle: "Capacità Ingegneristiche Multidisciplinari",
  description: "Il nostro team riunisce specialisti in ingegneria elettrica, progettazione meccanica, scienze ambientali e gestione di progetti per fornire soluzioni complete di energia rinnovabile che soddisfano i più alti standard tecnici e normativi.",
  items: {
    powerSystems: {
      title: "Analisi dei Sistemi Elettrici",
      description: "Analisi del flusso di carico, stabilità e guasti per reti elettriche complesse"
    },
    environmental: {
      title: "Impatto Ambientale",
      description: "Valutazioni ambientali complete e reportistica sulla sostenibilità"
    },
    gridCompliance: {
      title: "Conformità di Rete",
      description: "Consulenza sulla conformità normativa e aderenza ai codici di rete"
    },
    financial: {
      title: "Modellazione Finanziaria",
      description: "Analisi economica, proiezioni ROI e ottimizzazione degli investimenti"
    },
    projectManagement: {
      title: "Gestione Progetti",
      description: "Gestione completa del progetto, dalla fase di concept fino alla messa in servizio"
    },
    regulatory: {
      title: "Consulenza Normativa",
      description: "Sviluppo di strategie per permessi, licenze e conformità normativa"
    }
  }
};

export const cta = {
  title: "Pronto a discutere il tuo prossimo progetto?",
  button: "Contattaci",
  description: "Collabora con SALL Engineering per servizi di consulenza e ingegneria di livello mondiale nell'energia rinnovabile."
};

export const contact = {
  sectionLabel: "METTITI IN CONTATTO",
  sectionTitle: "Parliamo del Tuo Progetto",
  description: "Che tu stia pianificando una nuova installazione di energia rinnovabile o abbia bisogno di consulenza esperta per un progetto esistente, il nostro team è pronto ad aiutarti.",
  form: {
    fullName: "Nome Completo",
    company: "Azienda",
    email: "Email",
    phone: "Telefono",
    serviceInterest: "Servizio di Interesse",
    projectDetails: "Dettagli del Progetto",
    required: "*",
    maxCharacters: "Massimo 500 caratteri",
    submit: "Invia Richiesta",
    placeholders: {
      fullName: "Mario Rossi",
      company: "La Tua Azienda",
      email: "mario@azienda.com",
      phone: "+39 123 456 7890",
      projectDetails: "Raccontaci i requisiti del tuo progetto, la tempistica e le eventuali sfide specifiche che stai affrontando..."
    },
    serviceOptions: {
      select: "Seleziona un servizio",
      solar: "Sistemi di Energia Solare",
      wind: "Soluzioni di Energia Eolica",
      battery: "Sistemi di accumulo a batteria",
      grid: "Integrazione di Rete",
      general: "Consulenza Generale"
    },
    status: {
      sending: "Invio in corso...",
      success: "Grazie! Ti contatteremo presto.",
      error: "Qualcosa è andato storto. Riprova.",
      networkError: "Errore di rete. Riprova.",
      maxLength: "I dettagli del progetto devono essere di 500 caratteri o meno"
    }
  }
};

export const footer = {
  quickLinks: "Link Rapidi",
  contactTitle: "Contatti",
  email: "info@sallengineering.com",
  copyright: "© 2025 SALL Engineering. Tutti i diritti riservati.",
  privacy: "Informativa sulla Privacy",
  terms: "Termini di Servizio"
};
